/* pv-motion.js — Pedavia. This file IS the future assets/pv-motion.js (copied at port time).
   Vanilla, no deps. Reveal (descendant query + top<0 + rAF sweep), hero slideshow, word stagger,
   header pin. Reduced motion honoured. Re-inits on shopify:section:load. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  root.classList.add('js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal ---------- */
  function initReveal(scope) {
    var nodes = (scope || doc).querySelectorAll('.pv-r');
    if (!nodes.length) return;
    if (reduce || !('IntersectionObserver' in window)) { nodes.forEach(function (n) { n.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting || e.boundingClientRect.top < 0) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
    nodes.forEach(function (n) { io.observe(n); });
    var ticking = false;
    function sweep() {
      ticking = false;
      var h = window.innerHeight;
      nodes.forEach(function (n) {
        if (n.classList.contains('is-in')) return;
        var r = n.getBoundingClientRect();
        if (r.top < h * 0.9 && r.bottom > 0 || r.top < 0) { n.classList.add('is-in'); io.unobserve(n); }
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(sweep); } }, { passive: true });
    sweep();
  }

  /* ---------- hero slideshow ---------- */
  function initHero(hero) {
    var slides = [].slice.call(hero.querySelectorAll('.pv-hero__slide'));
    if (slides.length < 2) { if (slides[0]) slides[0].classList.add('is-active'); splitWords(hero); return; }
    var dots = [].slice.call(hero.querySelectorAll('.pv-hero__dot'));
    var ms = parseInt(getComputedStyle(hero).getPropertyValue('--pv-slide-ms')) || 7000;
    var i = 0, timer = null, paused = false;
    splitWords(hero);
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.forEach(function (d, k) {
        d.classList.remove('is-active');
        if (k === i) { void d.offsetWidth; d.classList.add('is-active'); }
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
    }
    function arm() { clearTimeout(timer); if (reduce || paused) return; timer = setTimeout(function () { show(i + 1); arm(); }, ms); }
    show(0); arm();
    hero.querySelectorAll('[data-pv-next]').forEach(function (b) { b.addEventListener('click', function () { show(i + 1); arm(); }); });
    hero.querySelectorAll('[data-pv-prev]').forEach(function (b) { b.addEventListener('click', function () { show(i - 1); arm(); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); arm(); }); });
    hero.addEventListener('mouseenter', function () { paused = true; clearTimeout(timer); });
    hero.addEventListener('mouseleave', function () { paused = false; arm(); });
    doc.addEventListener('visibilitychange', function () { if (doc.hidden) clearTimeout(timer); else arm(); });
    /* swipe */
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { show(dx < 0 ? i + 1 : i - 1); arm(); }
    }, { passive: true });
  }

  /* ---------- pins: anchor each product pin to the PHOTO (pin_x / pin_y are % of the image), not the box ----------
     The image is object-fit: cover with an object-position focus, so the visible crop changes with the viewport; this
     recomputes the pin in px from the rendered image box on load and resize. Mobile: the chip is static in the copy. */
  function initPins(hero) {
    var slides = [].slice.call(hero.querySelectorAll('.pv-hero__slide'));
    var mq = window.matchMedia('(max-width: 767px)');
    function place() {
      slides.forEach(function (s) {
        var pins = s.querySelector('.pv-hero__pins'), img = s.querySelector('.pv-hero__media img');
        if (!pins || !img) return;
        if (mq.matches) { pins.style.removeProperty('--pv-pin-x'); pins.style.removeProperty('--pv-pin-y'); pins.classList.remove('is-flipped'); return; }
        var px = parseFloat(pins.dataset.pinX), py = parseFloat(pins.dataset.pinY);
        var W = s.clientWidth, H = s.clientHeight, w = img.naturalWidth, h = img.naturalHeight;
        if (isNaN(px) || !W || !H || !w || !h) return;
        var fo = (getComputedStyle(img).objectPosition || '50% 50%').split(/\s+/);
        var fx = parseFloat(fo[0]) / 100, fy = parseFloat(fo[1] || '50%') / 100;
        if (isNaN(fx)) fx = 0.5; if (isNaN(fy)) fy = 0.5;
        var sc = Math.max(W / w, H / h), rw = w * sc, rh = h * sc, ox = (W - rw) * fx, oy = (H - rh) * fy;
        var x = ox + rw * px / 100, y = oy + rh * py / 100;
        var parent = pins.offsetParent || s, pr = parent.getBoundingClientRect(), sr = s.getBoundingClientRect();
        var left = sr.left - pr.left + x, top = sr.top - pr.top + y;
        var cw = pins.offsetWidth || 260, gutter = 24;
        var flip = (sr.left - pr.left + x + cw - 14 + gutter) > (sr.right - pr.left);
        pins.classList.toggle('is-flipped', flip);
        if (flip && left - cw + 14 < sr.left - pr.left + gutter) { pins.classList.remove('is-flipped'); left = Math.max(sr.left - pr.left + gutter + 14, Math.min(left, sr.right - pr.left - cw + 14 - gutter)); }
        var minTop = sr.top - pr.top + (pins.offsetHeight || 60) + 24 + 72;
        if (top < minTop) top = minTop;
        pins.style.setProperty('--pv-pin-x', Math.round(left) + 'px');
        pins.style.setProperty('--pv-pin-y', Math.round(top) + 'px');
      });
    }
    slides.forEach(function (s) { var img = s.querySelector('.pv-hero__media img'); if (img && !img.complete) img.addEventListener('load', place); });
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(place, 120); }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);
    place(); setTimeout(place, 600);
  }

  /* word stagger on the hero H1 only (words, never letters; aria kept intact) */
  function splitWords(scope) {
    scope.querySelectorAll('.pv-h1[data-pv-words]').forEach(function (h) {
      if (h.dataset.pvSplit) return;
      var text = h.textContent.trim();
      h.setAttribute('aria-label', text);
      var frag = doc.createDocumentFragment();
      var parts = [];
      [].forEach.call(h.childNodes, function (n) {
        if (n.nodeType === 3) { n.textContent.split(/\s+/).forEach(function (w) { if (w) parts.push({ w: w }); }); }
        else if (n.nodeType === 1) { parts.push({ el: n }); }
      });
      h.textContent = '';
      parts.forEach(function (p, k) {
        var span = doc.createElement('span');
        span.className = 'pv-hero__word'; span.style.setProperty('--w', k); span.setAttribute('aria-hidden', 'true');
        if (p.el) { p.el.classList.add('pv-hero__word'); p.el.style.setProperty('--w', k); p.el.setAttribute('aria-hidden', 'true'); frag.appendChild(p.el); }
        else { span.textContent = p.w; frag.appendChild(span); }
        if (k < parts.length - 1) frag.appendChild(doc.createTextNode(' '));
      });
      h.appendChild(frag); h.dataset.pvSplit = '1';
    });
  }


  /* ---------- steps: the stage photo follows the step nearest the viewport centre ---------- */
  function initSteps(sec) {
    var steps = [].slice.call(sec.querySelectorAll('.pv-steps__step'));
    var imgs = [].slice.call(sec.querySelectorAll('.pv-steps__stage img'));
    if (!steps.length) return;
    function activate(i) {
      steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); });
    }
    var ticking = false;
    function pick() {
      ticking = false;
      var mid = window.innerHeight * 0.45, best = 0, bd = Infinity;
      steps.forEach(function (s, k) { var r = s.getBoundingClientRect(); var d = Math.abs((r.top + r.height / 2) - mid); if (d < bd) { bd = d; best = k; } });
      activate(best);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(pick); } }, { passive: true });
    pick();
  }

  /* ---------- header pin after the hero ---------- */
  function initHeader(header) {
    var ticking = false;
    function check() {
      ticking = false;
      var limit = parseInt(getComputedStyle(header).getPropertyValue('--pv-pin-after')) || 24;
      header.classList.toggle('is-pinned', window.scrollY > limit);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    check();
  }

  function init(scope) {
    initReveal(scope);
    (scope || doc).querySelectorAll('.pv-hero').forEach(function (h) { if (!h.dataset.pvInit) { h.dataset.pvInit = '1'; initHero(h); initPins(h); } });
    (scope || doc).querySelectorAll('.pv-steps').forEach(function (h) { if (!h.dataset.pvInit) { h.dataset.pvInit = '1'; initSteps(h); } });
    (scope || doc).querySelectorAll('.pv-header').forEach(function (h) { if (!h.dataset.pvInit) { h.dataset.pvInit = '1'; initHeader(h); } });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
